import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  DialogTermsCond,
  ButtonHLPure,
  InputFileHLPure,
  CheckBoxHLPure,
} from "../../pures";
import { Grid } from "@material-ui/core";
import "./signature-request-profile-document.css";
import DialogPdf from "../../pures/signature-request-detail/dialog-pdf";
import { b64toBlob } from "./../../../validators";
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import SiganturePackageRequestProfileView from "../signature-request-profile-data/signature-package-request-profile.view";
import LabelPure from "../../pures/label/label.pure";

const SignatureRequestProfileDocumentView = (props) => {
  const { t } = useTranslation();
  const { step, onHandleBack, onHandleNext, signatureProfileSelected } = props;
  const { next, back } = step;
  const [blobUrl, setBlobUrl] = useState("");
  const [currentSystem, setCurrentSystem] = useState("");
  const [modalTermsCond, setModalTermsCond] = useState(null);
  const [selectedFileBase64, setSelectedFileBase64] = useState('')
  const [urlPdf, setUrlPdf] = useState('')

  const pdf = useMemo(() => <PdfReader className="pdfReader" file={selectedFileBase64} isFile src={`data:application/pdf;base64,${selectedFileBase64}`} fileName={props.selectedFileName}  ></PdfReader>, [selectedFileBase64])
  const pdfContractnegotiation = useMemo(() => <PdfReader className="pdfReader" url={urlPdf} awsURL src={urlPdf}  ></PdfReader>, [urlPdf])

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  const openModalTermsCond = (value) => {
    setModalTermsCond(value);
  };

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");

  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  if (isTouchScreendevice()) {
    isMobile = true;
  }

  useEffect(() => {
    if (props.selectedFileBase64 && !props.isContractFromNegotiation) {
      const blob = b64toBlob(props.selectedFileBase64, "application/pdf");
      setBlobUrl(blob);
      setSelectedFileBase64(props.selectedFileBase64)
    }
  }, [props.selectedFileBase64]);


  useEffect(() => {
    if (props.contractFromNegotiation && props.contractFromNegotiation.url) {
      setUrlPdf(props.contractFromNegotiation.url)
    }
  }, [props.contractFromNegotiation])

  const onHandleSubmit = () => {
    let validateData  = props.onValidateProfileData();
    if(validateData) onHandleNext();
  };

  return (
    <div className={"step-card-SiganturePackageRequestProfileView"}>
      <SiganturePackageRequestProfileView
        {...props}
      />

      {/* <Grid container lg={12} md={12} sm={12} es={12} spacing={3}>
        <Grid item xs={12}>
          <LabelPure title={`${t("signatureRequestProfileView.signatureName")} ${props.nameSignature}`} />
        </Grid>

        <Grid item xs={12}>
          <InputFileHLPure
            labelActive
            labelInputFile={t("signatureRequestView2.uploadDocument")}
            messageBtn={t("signatureRequestView2.pdf")}
            flex
            acceptFile={"application/pdf"}
            selectedFile={props.selectedFile}
            selectedFileName={props.selectedFileName}
            errorFile={props.errorFile}
            handleFile={props.handleFile}
            handleDeleteFile={props.handleDeleteFile}
          />
        </Grid>

        {/*View document*
        <Grid item xs={12}>
          <Grid container lg={12} md={12} sm={12} es={12}>
            {props.selectedFile && props.selectedFileBase64 && (
              <React.Fragment>
                {!isMobile && props.isContractFromNegotiation === false ? (
                  <Grid item lg={12} md={12} sm={12} es={12}>
                    {/* <embed type="application/pdf" name="document_pdf"
                    src={
                      props.selectedFileBase64
                        ? "data:application/pdf;base64," +
                        props.selectedFileBase64
                        : null
                    } className="canvas_container_pdf_render_profile" /> *
                    {selectedFileBase64 ? pdf : ""}
                    {/* <iframe
                    name="document_pdf"
                    id="myiframe"
                    src={
                      props.selectedFileBase64
                        ? "data:application/pdf;base64," +
                        props.selectedFileBase64 + "#toolbar=0"
                        : null
                    }
                    className="canvas_container_pdf_render_profile"
                  /> *
                  </Grid>
                ) : null}
                {!isMobile && props.isContractFromNegotiation === true ? (
                  <Grid item lg={12} md={12} sm={12} es={12}>
                    {pdfContractnegotiation}
                  </Grid>
                ) : null}
                {isMobile && (
                  <div className="pdf-btn-profile">
                    <DialogPdf blobUrl={blobUrl} />
                  </div>
                )}
              </React.Fragment>
            )}
            {props.selectedFile && props.selectedFileBase64 && (
              <div
                container
                xs={12}
                lg={12}
                md={12}
                sm={12}
                className="container-checkbox-confirm"
              >
                <Grid
                  item
                  xs={12}
                  className="checkBox-termsConditions"
                >
                  <p className="form-inputs-terms-conditions-profile">
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        openModalTermsCond(true);
                      }}
                    >
                      {t("signatureRequestView2.termsConditions")}
                    </a>
                  </p>
                  {/* {props.errorAcceptDocument && <span className='hint-message-error'>{t('signatureRequestView2.acceptUploadDocument')}</span>} *
                </Grid>
                <Grid
                  item
                  xs={12}
                >
                  <CheckBoxHLPure
                    labelCheckBox={t("signatureRequestView2.acceptUploadDocumentLegal")}
                    valueCheckBox={props.documentAccept}
                    idCheckBox={"document"}
                    onChangeHandler={props.handleChangeCheckbox}
                    checkedState={props.documentAccept}
                  />
                  {props.errorAcceptDocument && (
                    <span className="hint-message-error">
                      {t("signatureRequestView2.acceptUploadDocument")}
                    </span>
                  )}
                </Grid>
              </div>
            )}
          </Grid>
        </Grid>
      {/* </Grid>  */}

      <div className="action-buttons">
        <ButtonHLPure
          nameBtn={back}
          onClickBtn={onHandleBack}
        />
        <ButtonHLPure
          nameBtn={next}
          primary
          onClickBtn={onHandleSubmit}
        />
      </div>

      {/* <DialogTermsCond
        modalTermsCond={modalTermsCond}
        openModalTermsCond={openModalTermsCond}
      /> */}
    </div>
  );
};

export default SignatureRequestProfileDocumentView;
